export default __webpack_public_path__ + "static/media/openseaIcon.133c7444.svg";